import { Dispatch, StandardThunkAction } from 'app/gamma/src/types';
import { State } from 'app/gamma/src/modules/types';
import { getMyId } from 'app/gamma/src/selectors/session';
import { Noun, trackUe, Verb } from '@trello/analytics';
import API from 'app/gamma/src/api';
import { Action, actionCreator } from '@trello/redux';

export const REMOVE_MEMBER_FROM_BOARD = Symbol(
  'models/REMOVE_MEMBER_FROM_BOARD',
);

export type RemoveMemberFromBoardAction = Action<
  typeof REMOVE_MEMBER_FROM_BOARD,
  { idBoard: string; idMember: string }
>;

export const removeMemberFromBoardAction = actionCreator<
  RemoveMemberFromBoardAction
>(REMOVE_MEMBER_FROM_BOARD);

export const removeMemberFromBoard = ({
  idBoard,
  idMember,
}: {
  idBoard: string;
  idMember: string;
}): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    try {
      await API.client.rest.del(`boards/${idBoard}/members/${idMember}`);
      dispatch(removeMemberFromBoardAction({ idBoard, idMember }));

      trackUe({
        category: Noun.BOARD,
        verb: Verb.REMOVES,
        directObj: Noun.MEMBER,
        method: 'any method available to remove a memeber on a board',
        context: {
          member: idMember,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
};

export const removeMeFromBoard = ({
  idBoard,
}: {
  idBoard: string;
}): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    const myId = getMyId(getState());
    dispatch(removeMemberFromBoard({ idBoard, idMember: myId }));

    trackUe({
      category: Noun.BOARD,
      verb: Verb.REMOVES,
      directObj: Noun.MEMBER,
      method: 'any method available to remove self from a board',
      context: {
        member: myId,
      },
    });
  };
};
